import { Dto, DtoWithId } from "@mango/core";

@Dto({fullName: "CIJBorculo.Logic.Alert"})
export class Alert extends DtoWithId {
	title: string;
	message: string;
	date: Date;
	type: number;
	expiringDate: Date;
	valid: Boolean;
}